import { collection, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { FaMale, FaFemale } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";

// הוספת טיפוס עזר
type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

// המרת האייקונים לקומפוננטות React
const MaleIcon = FaMale as unknown as IconComponent;
const FemaleIcon = FaFemale as unknown as IconComponent;

interface User {
  id: string;
  name: string;
  gender: "male" | "female";
}

const UserSelection: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [selectedGender, setSelectedGender] = useState<
    "male" | "female" | null
  >(null);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const savedUserId = localStorage.getItem("selectedUserId");
    const savedUserGender = localStorage.getItem("selectedUserGender") as
      | "male"
      | "female"
      | null;

    if (savedUserId && savedUserGender) {
      navigate("/toilet-status");
      return;
    }

    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const usersData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as User[];
        setUsers(usersData);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [navigate]);

  useEffect(() => {
    if (selectedGender) {
      setFilteredUsers(users.filter((user) => user.gender === selectedGender));
    }
  }, [selectedGender, users]);

  const handleGenderSelect = (gender: "male" | "female") => {
    setSelectedGender(gender);
  };

  const handleUserSelect = (user: User) => {
    localStorage.setItem("selectedUserId", user.id);
    localStorage.setItem("selectedUserName", user.name);
    localStorage.setItem("selectedUserGender", user.gender);
    navigate("/toilet-status");
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!selectedGender) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <h1 className="text-3xl font-bold mb-8">בחר את המין שלך</h1>
        <div className="flex gap-8">
          <button
            onClick={() => handleGenderSelect("male")}
            className="flex flex-col items-center justify-center w-48 h-48 bg-blue-500 text-white rounded-lg shadow-lg hover:bg-blue-600 transition-colors"
          >
            <MaleIcon className="mb-4 w-12 h-12" />
            <span className="text-xl">זכר</span>
          </button>
          <button
            onClick={() => handleGenderSelect("female")}
            className="flex flex-col items-center justify-center w-48 h-48 bg-pink-500 text-white rounded-lg shadow-lg hover:bg-pink-600 transition-colors"
          >
            <FemaleIcon className="mb-4 w-12 h-12" />
            <span className="text-xl">נקבה</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <h1 className="text-3xl font-bold mb-8">בחר את שמך</h1>
      <div className="grid grid-cols-2 gap-4 max-w-2xl w-full">
        {filteredUsers.map((user) => (
          <button
            key={user.id}
            onClick={() => handleUserSelect(user)}
            className="p-4 bg-white rounded-lg shadow-md hover:bg-gray-100 transition-colors text-xl"
          >
            {user.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserSelection;
